<div class="companies-container view">
    @if (isLoading) {
        <div class="loading">
            <mat-spinner color="accent" diameter="40"></mat-spinner>
            <p>Loading search filters...</p>
        </div>
    }

    @if (error) {
        <div class="error-message">
            <mat-icon>error</mat-icon>
            <p>{{ error }}</p>
        </div>
    }

    @if (!isLoading) {
        <mat-card class="cardPlain">
            <div class="custom-card-header">
                <div class="section-header">
                    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
                    <h1 class="m-0 f-w-500">Search</h1>
                    <p class="m-0 help-text">
                        {{ localSearchOnly ? 'Local search mode: search registry data and edit filters. HubSpot import and automatic sync are disabled.' : 'Search Brønnøysund and import companies into HubSpot for Shine Enrich.' }}
                    </p>
                </div>
            </div>
            <mat-card-content class="d-flex flex-col gap-24">
                <mat-tab-group
                        (selectedTabChange)="onTabChange($event)"
                        [selectedIndex]="selectedIndex"
                        animationDuration="0ms"
                        class="webinar-tabs"
                >
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>search</mat-icon>
                            <span>Search</span>
                        </ng-template>
                        <ng-template matTabContent>
                            <form (ngSubmit)="searchCompanies()" [formGroup]="searchForm"
                                  class="d-flex flex-col gap-24 form-no-subscripts">
          <p class="f-s-14" aria-live="polite">
            @if (facets.loading()) { Updating filter options… }
            @else if (facets.error()) { {{ facets.error() }} <button mat-button type="button" (click)="facets.retry()">Retry</button> }
            @else { Options and counts reflect the other active filters. }
          </p>
                                <section class="tab-section d-flex flex-col gap-16">
                                    <div class="section-header">
                                        <h4 class="m-0 f-s-16 f-w-600">Basic filters</h4>
                                        <p class="m-0 f-s-14 text-gray-100">Narrow down your company search.</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Company name</mat-label>
                                                <input formControlName="companyName" matInput
                                                       placeholder="Enter company name"/>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Organization number</mat-label>
                                                <input formControlName="orgNumber" matInput
                                                       placeholder="Enter organization number"/>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Postal code</mat-label>
                                                <input formControlName="postalCode" matInput
                                                       placeholder="Enter postal code"/>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="NACE code" formControlName="naceCode"
                  [options]="filterOptions['nace_code1'] || []"></app-filter-multiselect>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="Employee group" formControlName="employeeGroup"
                  [options]="filterOptions['number_of_employees_group'] || []"></app-filter-multiselect>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>City</mat-label>
                                                <input formControlName="city" matInput placeholder="Enter city"/>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="Municipality" formControlName="municipality"
                  [options]="filterOptions['municipality'] || []"></app-filter-multiselect>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="Region" formControlName="region" (selectionChange)="regionSelectionChanged = true"
                  [options]="filterOptions['region'] || []"></app-filter-multiselect>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="Organization type" formControlName="organization_type"
                  [options]="filterOptions['organization_type'] || []"></app-filter-multiselect>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Accounting year</mat-label>
                                                <input formControlName="accounting_year" matInput
                                                       placeholder="Enter accounting year"/>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </section>
                                <mat-accordion multi class="filter-sections">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            Registration filters
                                            @if (registrationFilterCount > 0) {
                                                <span class="filter-section-count">{{ registrationFilterCount }} set</span>
                                            }
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="f-s-14 text-gray-100">Filter by registry status flags.</p>
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <mat-checkbox formControlName="vat_registered">VAT registered</mat-checkbox>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <mat-checkbox formControlName="in_company_register">In company register
                                            </mat-checkbox>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <mat-checkbox formControlName="in_foundation_register">In foundation
                                                register
                                            </mat-checkbox>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <mat-checkbox formControlName="in_voluntary_register">In voluntary
                                                register
                                            </mat-checkbox>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <mat-checkbox formControlName="in_party_register">In party register
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            Numeric filters
                                            @if (numericFilterCount > 0) {
                                                <span class="filter-section-count">{{ numericFilterCount }} set</span>
                                            }
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p class="f-s-14 text-gray-100">Compare numeric fields using operators.</p>
                                    <div class="d-flex flex-col gap-16">
                                        <div class="numeric-filter d-flex flex-col gap-12"
                                             formGroupName="number_of_employees">
                                            <h5 class="m-0 f-s-14 f-w-600">Number of employees</h5>
                                            <div class="operator-row">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Comparison</mat-label>
                                                    <mat-select formControlName="operator">
                                                        @for (op of comparisonOperators; track op) {
                                                            <mat-option [value]="op.value">
                                                                {{ op.label }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                                @if (searchForm.get('number_of_employees.operator')?.value !== 'between') {
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Value</mat-label>
                                                        <input formControlName="value" matInput placeholder="Enter value"
                                                               type="number"/>
                                                    </mat-form-field>
                                                }
                                                @if (searchForm.get('number_of_employees.operator')?.value === 'between') {
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Min</mat-label>
                                                        <input formControlName="min" matInput placeholder="Minimum"
                                                               type="number"/>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Max</mat-label>
                                                        <input formControlName="max" matInput placeholder="Maximum"
                                                               type="number"/>
                                                    </mat-form-field>
                                                }
                                            </div>
                                        </div>
                                        <div class="numeric-filter d-flex flex-col gap-12"
                                             formGroupName="latest_annual_revenue">
                                            <h5 class="m-0 f-s-14 f-w-600">Latest annual revenue</h5>
                                            <div class="operator-row">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Comparison</mat-label>
                                                    <mat-select formControlName="operator">
                                                        @for (op of comparisonOperators; track op) {
                                                            <mat-option [value]="op.value">
                                                                {{ op.label }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                                @if (searchForm.get('latest_annual_revenue.operator')?.value !== 'between') {
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Value</mat-label>
                                                        <input formControlName="value" matInput placeholder="Enter value"
                                                               type="number"/>
                                                    </mat-form-field>
                                                }
                                                @if (searchForm.get('latest_annual_revenue.operator')?.value === 'between') {
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Min</mat-label>
                                                        <input formControlName="min" matInput placeholder="Minimum"
                                                               type="number"/>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Max</mat-label>
                                                        <input formControlName="max" matInput placeholder="Maximum"
                                                               type="number"/>
                                                    </mat-form-field>
                                                }
                                            </div>
                                        </div>
                                        <div class="numeric-filter d-flex flex-col gap-12" formGroupName="latest_ebit">
                                            <h5 class="m-0 f-s-14 f-w-600">Latest EBIT</h5>
                                            <div class="operator-row">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Comparison</mat-label>
                                                    <mat-select formControlName="operator">
                                                        @for (op of comparisonOperators; track op) {
                                                            <mat-option [value]="op.value">
                                                                {{ op.label }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                                @if (searchForm.get('latest_ebit.operator')?.value !== 'between') {
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Value</mat-label>
                                                        <input formControlName="value" matInput placeholder="Enter value"
                                                               type="number"/>
                                                    </mat-form-field>
                                                }
                                                @if (searchForm.get('latest_ebit.operator')?.value === 'between') {
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Min</mat-label>
                                                        <input formControlName="min" matInput placeholder="Minimum"
                                                               type="number"/>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Max</mat-label>
                                                        <input formControlName="max" matInput placeholder="Maximum"
                                                               type="number"/>
                                                    </mat-form-field>
                                                }
                                            </div>
                                        </div>
                                        <div class="numeric-filter d-flex flex-col gap-12"
                                             formGroupName="latest_sum_equity">
                                            <h5 class="m-0 f-s-14 f-w-600">Latest sum equity</h5>
                                            <div class="operator-row">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Comparison</mat-label>
                                                    <mat-select formControlName="operator">
                                                        @for (op of comparisonOperators; track op) {
                                                            <mat-option [value]="op.value">
                                                                {{ op.label }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                                @if (searchForm.get('latest_sum_equity.operator')?.value !== 'between') {
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Value</mat-label>
                                                        <input formControlName="value" matInput placeholder="Enter value"
                                                               type="number"/>
                                                    </mat-form-field>
                                                }
                                                @if (searchForm.get('latest_sum_equity.operator')?.value === 'between') {
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Min</mat-label>
                                                        <input formControlName="min" matInput placeholder="Minimum"
                                                               type="number"/>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Max</mat-label>
                                                        <input formControlName="max" matInput placeholder="Maximum"
                                                               type="number"/>
                                                    </mat-form-field>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                                </mat-accordion>
                                <mat-card-actions align="end" class="action-buttons p-0">
                                    <button
                                            [disabled]="isSearching || isImporting"
                                            class="d-inline-flex align-items-center gap-6"
                                            color="primary"
                                            mat-flat-button
                                            type="submit"
                                    >
                                        <mat-icon>search</mat-icon>
                                        Search
                                    </button>
                                    <button
                                            (click)="resetForm()"
                                            [disabled]="isSearching || isImporting"
                                            class="d-inline-flex align-items-center gap-6"
                                            color="primary"
                                            mat-stroked-button
                                            type="button"
                                    >
                                        <mat-icon>refresh</mat-icon>
                                        Reset
                                    </button>
                                </mat-card-actions>
                            </form>
                            @if (isSearching) {
                                <div class="loading">
                                    <mat-spinner color="accent" diameter="40"></mat-spinner>
                                    <p>Searching companies...</p>
                                </div>
                            }
                            @if (hasSearched) {
                                <section class="tab-section d-flex flex-col gap-12">
                                    <div class="section-header">
                                        <h4 class="m-0 f-s-16 f-w-600">Search results</h4>
                                        <p class="m-0 f-s-14 text-gray-100">
                                            Showing {{ formatNumber(companies.length) }} of {{ formatNumber(totalCount) }} companies.
                                        </p>
                                    </div>
                                    @if (companies.length > 0) {
                                    <div class="table-responsive">
                                        <table [dataSource]="companies" class="webinars-table webinars-table--inner-padding"
                                               mat-table>
                                            <ng-container matColumnDef="company_name">
                                                <th *matHeaderCellDef mat-header-cell>Company name</th>
                                                <td *matCellDef="let company" mat-cell>
                                                    <button
                                                            (click)="viewCompany(company)"
                                                            class="company-name-link"
                                                            color="primary"
                                                            mat-button
                                                            type="button"
                                                    >
                                                        {{ company.company_name }}
                                                    </button>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="company_id">
                                                <th *matHeaderCellDef mat-header-cell>Org number</th>
                                                <td *matCellDef="let company" mat-cell>{{ company.company_id }}</td>
                                            </ng-container>
                                            <ng-container matColumnDef="postal_place">
                                                <th *matHeaderCellDef mat-header-cell>Location</th>
                                                <td *matCellDef="let company" mat-cell>
                                                    {{ company.postal_code }} {{ company.city ?? company.postal_place }}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="employees">
                                                <th *matHeaderCellDef mat-header-cell>Employees</th>
                                                <td *matCellDef="let company"
                                                    mat-cell>{{ company.number_of_employees_group }}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="accounting_year">
                                                <th *matHeaderCellDef mat-header-cell>Latest accounts</th>
                                                <td *matCellDef="let company" mat-cell>{{ company.accounting_year }}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="actions">
                                                <th *matHeaderCellDef class="text-center" mat-header-cell>Import</th>
                                                <td *matCellDef="let company" class="text-center" mat-cell>
                                                    @if (!isCompanyImported(company.company_id)) {
                                                        <button
                                                                (click)="importCompany(company)"
                                                                [disabled]="isImporting"
                                                                class="d-inline-flex align-items-center gap-6"
                                                                color="primary"
                                                                mat-flat-button
                                                                matTooltip="Import to HubSpot"
                                                                type="button"
                                                        >
                                                            <mat-icon>{{ isImporting ? 'hourglass_top' : 'download' }}</mat-icon>
                                                            {{ isImporting ? 'Importing…' : 'Import' }}
                                                        </button>
                                                    }
                                                    @if (isCompanyImported(company.company_id)) {
                                                        <mat-icon
                                                                color="primary"
                                                                matTooltip="Company imported to HubSpot"
                                                        >
                                                            check_circle
                                                        </mat-icon>
                                                    }
                                                </td>
                                            </ng-container>
                                            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                                            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
                                        </table>
                                    </div>
                                    } @else {
                                        <div class="empty-state">
                                            <mat-icon>search_off</mat-icon>
                                            <span>No companies match this segment.</span>
                                        </div>
                                    }
                                </section>
                            }
                        </ng-template>
                    </mat-tab>
                    <mat-tab [disabled]="localSearchOnly">
                        <ng-template mat-tab-label>
                            <mat-icon>cloud_download</mat-icon>
                            <span>Imported</span>
                        </ng-template>
                        <ng-template matTabContent>
                            <div class="tab-content d-flex flex-col gap-16">
                                <div class="imported-header">
                                    <div class="section-header">
                                        <h4 class="m-0 f-s-16 f-w-600">Imported companies</h4>
                                        <p class="m-0 f-s-14 text-gray-100">
                                            Companies imported or synced to HubSpot by Shine Enrich.
                                        </p>
                                    </div>
                                    <button
                                            (click)="loadImportedCompanies(true)"
                                            [disabled]="isLoadingImported"
                                            class="d-inline-flex align-items-center gap-6"
                                            color="primary"
                                            mat-stroked-button
                                            type="button"
                                    >
                                        <mat-icon>refresh</mat-icon>
                                        Refresh
                                    </button>
                                </div>

                                @if (importedError) {
                                    <div class="error-message">
                                        <mat-icon>error</mat-icon>
                                        <p>{{ importedError }}</p>
                                    </div>
                                }

                                @if (isLoadingImported) {
                                    <div class="loading">
                                        <mat-spinner color="accent" diameter="40"></mat-spinner>
                                        <p>Loading imported companies...</p>
                                    </div>
                                }

                                @if (!isLoadingImported && importedHubspotCompanies.length === 0 && !importedError) {
                                    <div class="empty-state">
                                        <mat-icon>cloud_download</mat-icon>
                                        <p class="m-0 f-s-14 text-gray-100">No imported companies found.</p>
                                    </div>
                                }

                                @if (!isLoadingImported && importedHubspotCompanies.length > 0) {
                                    <div class="table-responsive">
                                        <table
                                                [dataSource]="importedHubspotCompanies"
                                                class="webinars-table webinars-table--inner-padding"
                                                mat-table
                                        >
                                            <ng-container matColumnDef="name">
                                                <th *matHeaderCellDef mat-header-cell>Company name</th>
                                                <td *matCellDef="let company" mat-cell>
                                                    <button
                                                            (click)="viewImportedCompany(company)"
                                                            [disabled]="!getImportedCompanyOrgNumber(company)"
                                                            class="company-name-link"
                                                            color="primary"
                                                            mat-button
                                                            type="button"
                                                    >
                                                        {{ getImportedCompanyName(company) }}
                                                    </button>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="org_number">
                                                <th *matHeaderCellDef mat-header-cell>Org number</th>
                                                <td *matCellDef="let company" mat-cell>
                                                    {{ getImportedCompanyOrgNumber(company) || '-' }}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="domain">
                                                <th *matHeaderCellDef mat-header-cell>Domain</th>
                                                <td *matCellDef="let company" mat-cell>
                                                    {{ getImportedCompanyDomain(company) }}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="last_synced_at">
                                                <th *matHeaderCellDef mat-header-cell>Last synced</th>
                                                <td *matCellDef="let company" mat-cell>
                                                    {{ getImportedCompanyLastSyncedAt(company) }}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="actions">
                                                <th *matHeaderCellDef class="text-center" mat-header-cell>Details</th>
                                                <td *matCellDef="let company" class="text-center" mat-cell>
                                                    <button
                                                            (click)="viewImportedCompany(company)"
                                                            [disabled]="!getImportedCompanyOrgNumber(company)"
                                                            color="primary"
                                                            mat-icon-button
                                                            matTooltip="View registry details"
                                                            type="button"
                                                    >
                                                        <mat-icon>open_in_new</mat-icon>
                                                    </button>
                                                </td>
                                            </ng-container>
                                            <tr *matHeaderRowDef="importedDisplayedColumns" mat-header-row></tr>
                                            <tr *matRowDef="let row; columns: importedDisplayedColumns" mat-row></tr>
                                        </table>
                                    </div>
                                }

                                @if (!isLoadingImported && importedTruncation === 'provider-result-limit') {
                                    <div class="d-flex align-items-center gap-8 text-gray-100" role="status">
                                        <mat-icon>info</mat-icon>
                                        <p class="m-0 f-s-14">Imported companies are limited to the provider's first 10,000 matching records.</p>
                                    </div>
                                }

                                @if (!importedError && hasLoadedImportedCompanies) {
                                    <div class="d-flex align-items-center justify-content-between gap-12">
                                        <button
                                                (click)="loadPreviousImportedCompaniesPage()"
                                                [disabled]="isLoadingImported || !hasPreviousImportedCompaniesPage()"
                                                aria-label="Load previous imported companies page"
                                                mat-stroked-button
                                                type="button"
                                        >
                                            <mat-icon>chevron_left</mat-icon>
                                            Previous
                                        </button>
                                        <span class="f-s-14 text-gray-100">Page {{ getImportedCompaniesPageNumber() }}</span>
                                        <button
                                                (click)="loadNextImportedCompaniesPage()"
                                                [disabled]="isLoadingImported || !importedNextAfter"
                                                aria-label="Load next imported companies page"
                                                mat-stroked-button
                                                type="button"
                                        >
                                            Next
                                            <mat-icon>chevron_right</mat-icon>
                                        </button>
                                    </div>
                                }
                            </div>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </mat-card-content>
        </mat-card>
    }
</div>
